import { ref, watch, type WatchStopHandle } from 'vue';
import { useMagicKeys } from '@vueuse/core';
import { HOT_KEY_ACTIONS } from './constants';
import type { HotKeyHandler, HotKeyContext, HandlerFunction } from './types';

export function useHotKeys(): HotKeyContext {
  const handlers = ref<Map<string, HandlerFunction>>(new Map());
  const keys = useMagicKeys();
  const watchers = ref<WatchStopHandle[]>([]);

  const registerHandler = (handlerConfig: HotKeyHandler) => {
    handlers.value.set(handlerConfig.actionId, handlerConfig.handler);
  };

  const unregisterHandler = (actionId: string) => {
    handlers.value.delete(actionId);
  };

  const setupHotKeys = () => {
    HOT_KEY_ACTIONS.forEach((action) => {
      const watcher = watch(keys[action.key], (isKeyPressed) => {
        if (isKeyPressed) {
          const handler = handlers.value.get(action.id);
          if (handler) {
            handler();
          }
        }
      });
      watchers.value.push(watcher);
    });
  };

  const cleanupHotKeys = () => {
    watchers.value.forEach(stop => stop());
    watchers.value = [];
    handlers.value.clear();
  };

  return {
    registerHandler,
    unregisterHandler,
    setupHotKeys,
    cleanupHotKeys,
  };
}
